/* eslint-disable no-plusplus */
/* eslint-disable import/prefer-default-export */

import { AxiosResponse } from 'axios';
import { LocationHelper } from '../../utils/LocationHelper';

export class MocksHelper {
  static useMocks = () => {
    const urlParams = LocationHelper.getParametersFromUrl();
    const mocked =
      process.env.REACT_APP_API !==
        'https://areacliente.eroski.es/areacliente' &&
      urlParams.useMocks &&
      urlParams.useMocks === 'true';
    return mocked;
  };

  static adjustArrayToTriggerState = (array: any[], setState: any) => {
    // eslint-disable-next-line react-hooks/rules-of-hooks
    if (MocksHelper.useMocks()) {
      const temp = array.slice(0, -1);
      setState(temp);
    }
  };

  static getAxiosResponse = (data: object) => {
    const axiosResponse: AxiosResponse = {
      data,
      status: 200,
      statusText: 'OK',
      config: {},
      headers: { id: MocksHelper.generateRandomId() },
    };
    return axiosResponse;
  };

  private static generateRandomId = () => {
    let result = '';
    const characters =
      'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
    const charactersLength = characters.length;
    for (let i = 0; i < 6; i++) {
      result += characters.charAt(Math.floor(Math.random() * charactersLength));
    }
    return result;
  };
}
